import { render, staticRenderFns } from "./CPFInput.vue?vue&type=template&id=139eb1a5"
import script from "./CPFInput.vue?vue&type=script&lang=ts"
export * from "./CPFInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports